import { eventDivisionIsPlatformPaymentOrFree, isDinglesDivision } from '../../../../../utils/events';
import { utrTypeIds, paymentProviderTypeIds } from '../../../../../utils/eventConstants';

export function computeDivisionFees({ event, selectedDivisionIds, isPowered, clubVerificationFee, initialRegTotal }) {
    const { workflowVersion, paymentProviderTypeId } = event;
    let eventFee = 0;
    let eventFeeOffPlatform = 0;

    event.eventDivisions.forEach((div) => {
        if (!selectedDivisionIds.includes(div.id)) {
            return;
        }
        const isPlatformPaymentOrFree = eventDivisionIsPlatformPaymentOrFree(div);
        const addToEventFee = isPlatformPaymentOrFree && !event.allowOffPlatformPayments;
        const isDivisionDingles = isDinglesDivision(div);

        if (!isPowered &&
            event.utrTypeId === utrTypeIds.SANCTIONED &&
            workflowVersion > 1 &&
            clubVerificationFee > 0 &&
            addToEventFee &&
            !isDivisionDingles) {
            eventFee += (div.entryFee + clubVerificationFee);
        } else if (addToEventFee) {
            eventFee += div.entryFee;
        } else {
            eventFeeOffPlatform += div.entryFee;
        }
    });

    const chargeableEventFee = eventFee > 0 && paymentProviderTypeId === paymentProviderTypeIds.STRIPE ? eventFee : 0;
    const total = chargeableEventFee + initialRegTotal;

    return { eventFee, eventFeeOffPlatform, total };
}
